const getSwiftsellActiveTimeRange = (hoursFrom = 0, hoursTo = 12) => {
  // UTC + 5:30
  const ISTOffset = 5.5 * 60 * 60 * 1000;

  const currentDate = new Date();
  const currentDateIST = new Date(currentDate.getTime() + ISTOffset);
  const currentHoursIST = currentDateIST.getUTCHours();

  return currentHoursIST >= hoursFrom && currentHoursIST < hoursTo;
};

export default getSwiftsellActiveTimeRange;
